// import React, { useEffect } from 'react';
// import './App.css';
// import Login from './pages/Login';
// import { useDispatch } from "react-redux";
// import { loadUser } from './redux/actions/authActions';
// import { ToastContainer } from "react-toastify";
// import { Route ,Routes} from 'react-router-dom';
// import "react-toastify/dist/ReactToastify.css";
// import Dashboard from './pages/Dashboard';
// import Protected from './Protected';




// function App() {

//   const dispatch = useDispatch();

//   useEffect(() => {
//     dispatch(loadUser());
//   }, [dispatch]);



//   return (
//    <>
//    <ToastContainer />
//      <Routes>
//        <Route  path="/"   element={<Login />} />
//        <Route  path="/login"   element={<Login />} />
//        <Route  path="/dashboard/*"  element={<Protected><Dashboard /></Protected>} />
//        <Route   path={"*"} element={<h1 style={{textAlign:'center',marginTop:'100px'}}>404 Not found!</h1>}/>
         
//        {/* <div className="App">
//       <Login />
//     </div> */}
//      </Routes>
//    </>
    
//   );
// }

// export default App;

// src/App.js
import React, { useEffect } from 'react';
import './App.css';
import Login from './pages/Login';
import { useDispatch } from "react-redux";
import { loadUser } from './redux/actions/authActions';
import { ToastContainer } from "react-toastify";
import { Route, Routes } from 'react-router-dom';
import "react-toastify/dist/ReactToastify.css";
import Dashboard from './pages/Dashboard';
import Protected from './Protected';
import NotFound from './pages/NotFound';
import Unauthorized from './pages/Unauthorized';

function App() {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(loadUser());
  }, [dispatch]);

  return (
    <>
      <ToastContainer />
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/login" element={<Login />} />
        <Route 
          path="/dashboard/*" 
          element={
            <Protected>
              <Dashboard />
            </Protected>
          } 
        />
        <Route path="/unauthorized" element={<Unauthorized />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </>
  );
}

export default App;